const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-sensitivecontent-banner'] = {
        c: () => require('partner/modules/moe-sensitivecontent-banner/moe-sensitivecontent-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-sensitivecontent-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-sensitivecontent-banner'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-sensitivecontent-banner|moe-sensitivecontent-banner'] = {
                c: () => require('partner/modules/moe-sensitivecontent-banner/moe-sensitivecontent-banner.view.tsx'),
                cn: '__local__-__local__-moe-sensitivecontent-banner'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };